import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { message, Space } from "antd";
import InterfaceTable from "../../Table/InterfaceTable";
import {
  getSdgsByProject,
  deleteSdgByProject,
} from "../Application/Projects.business";
import { getSdgsSelector } from "../Infrastructure/Projects.reducer";
import { DeleteIcon, ModalDeleteConfirm } from "../../Utils/UI/Text";
import DoubleClickEditLabel from "../../DoubleClickEditLabel/UI/DoubleClickEditLabel";

const SdgsProjectTable = () => {
  const { id } = useParams();
  const sdgs = useSelector(getSdgsSelector);
  console.log(JSON.stringify(sdgs));

  useEffect(() => {
    if (id) {
      getSdgsByProject(id);
    }
  }, [id]);

  const handleDelete = (sdgId) => {
    ModalDeleteConfirm({
      title: "¿Está seguro de que desea eliminar este SDG?",
      messageOnOk: "SDG eliminado exitosamente",
      onConfirm: async () => {
        try {
          await deleteSdgByProject(id, sdgId);
          getSdgsByProject(id);
        } catch (error) {
          message.error("Se produjo un error, vuelva a intentarlo.");
        }
      },
      onCancel: () => {},
    });
  };

  const columns = [
    {
      title: "Título",
      dataIndex: "title",
      key: "title",
      render: (text, record) => {
        console.log("RECORD:", record.id);
        return (
          <DoubleClickEditLabel
            str={text}
            labelKey="title"
            type="sdg"
            id={id}
            id_resource={record.id || record._id || ""}
            onRefresh={() => getSdgsByProject(id)}
            confirmBeforeEdit={true}
          />
        );
      },
    },
    {
      title: "Datos",
      dataIndex: "data",
      key: "data",
    },
    {
      title: "Acciones",
      dataIndex: "",
      key: "",
      render: (_, record) => {
        return (
          <>
            <Space size="middle">
              <DeleteIcon
                TooltipDelete="¿Estás seguro de eliminar este SDG?"
                onClick={() => handleDelete(record.id)}
              />
            </Space>
          </>
        );
      },
    },
  ];

  return (
    <InterfaceTable
      rowKey="id"
      data={sdgs.resources || []}
      columns={columns}
      table="table-sdgs"
    />
  );
};

export default SdgsProjectTable;
